module.exports = __webpack_public_path__ + "static/img/pay_fail_joychat.e9c739c8.webp";